<script setup>
import Result from '../components/Result.vue';
import {useSearchStore} from "../store/useSearchStore";
import {computed} from "vue";
const store = useSearchStore();

const props = defineProps({
    results: {
        type: Array,
        default: null,
    },
    pageResults: {
        type: Array,
        default: null,
    },
    searchQuery: {
        type: String,
        default: null,
    },
    searchTyp: {
        type: String,
        default: null,
    },
    currentPage: {
        type: Number,
        default: null,
    },
    totalResults: {
        type: Number,
        default: null,
    },
    busy: Boolean,

    selectedFacets: {
        type: Array,
        default: null,
    },
    documentTypes: {
        type: Array,
        default: null,
    }
})

const selectedFacets = computed(() => props.selectedFacets);
const myResults = computed(() => props.results);

</script>

<template>
    <div class="search-results">
        <template v-for="(result, index) in myResults">
            <Result
                v-if="result.show"
                :key="`search-result-${index}`"
                :data="result"
                :passed-selected-facets="selectedFacets"
            />
        </template>
    </div>
</template>
